import styled, { css } from 'styled-components';

import { Button } from '@xing-com/button';
import {
  mediaTopBarHidden,
  mediaTopBarVisible,
  zIndexElevatedLayer4,
} from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceM,
  xdlColorBackground,
  xdlColorModalBorder,
  cornerRadiusXL,
  scale005,
  dropShadowM,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';

import { DEFAULT_HEIGHT_CONSTRAINTS } from '../input';

export const VARIABLES = {
  HEIGHT: '--container-height',
  MAX_HEIGHT: '--container-max-height',
  ERROR_BANNER_HEIGHT: '--error-banner-height',
};

const withErrorStyles = css`
  && textarea {
    padding-bottom: calc(var(${VARIABLES.ERROR_BANNER_HEIGHT}) + 20px);
    scroll-padding-bottom: calc(var(${VARIABLES.ERROR_BANNER_HEIGHT}) + 20px);

    @media ${mediaTopBarVisible} {
      min-height: calc(
        ${DEFAULT_HEIGHT_CONSTRAINTS.TOP_BAR_VISIBLE.MIN_HEIGHT}px +
          var(${VARIABLES.ERROR_BANNER_HEIGHT})
      );
      max-height: calc(
        ${DEFAULT_HEIGHT_CONSTRAINTS.TOP_BAR_VISIBLE.MAX_HEIGHT}px +
          var(${VARIABLES.ERROR_BANNER_HEIGHT})
      );
    }

    @media ${mediaTopBarHidden} {
      min-height: calc(
        ${DEFAULT_HEIGHT_CONSTRAINTS.TOP_BAR_VISIBLE.MIN_HEIGHT}px +
          var(${VARIABLES.ERROR_BANNER_HEIGHT})
      );
      max-height: calc(
        ${DEFAULT_HEIGHT_CONSTRAINTS.TOP_BAR_HIDDEN.MAX_HEIGHT}px +
          var(${VARIABLES.ERROR_BANNER_HEIGHT})
      );
    }
  }
`;

type ContainerProps = { $withErrorBanner?: boolean };
export const SuggestionsContainer = styled.div<ContainerProps>`
  margin-top: auto;
  grid-area: key;
  position: relative;
  width: 100%;

  @media ${mediaTopBarVisible} {
    min-height: ${DEFAULT_HEIGHT_CONSTRAINTS.TOP_BAR_VISIBLE.MIN_HEIGHT}px;
  }

  @media ${mediaTopBarHidden} {
    min-height: ${DEFAULT_HEIGHT_CONSTRAINTS.TOP_BAR_HIDDEN.MIN_HEIGHT}px;
  }

  ${({ $withErrorBanner }) => ($withErrorBanner ? withErrorStyles : '')}
`;

/**
 * Once issue with the bottom banner is that, since it does not go to the bottom of the
 * autocomplete, if the user scrolls to the top and there's enough text to go under the banner
 * it will be displayed, where there is space between the bottom and the bottom of the banner.
 * This is a workaround to fill the space with the background color.
 */
export const ErrorBannerContainer = styled.div`
  position: absolute;
  bottom: 2px;
  left: 20px;
  right: 20px;
  padding-bottom: 18px;
  background-color: ${xdlColorBackground};
  border-top-left-radius: ${cornerRadiusXL};
  border-top-right-radius: ${cornerRadiusXL};
`;

export const ErrorBanner = styled.div`
  background-color: ${xdlColorBackgroundTertiary};
  padding: ${spaceM};
  padding-right: 42px;
  border-radius: ${cornerRadiusXL};
`;

export const ErrorClose = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;
`;

export const FloatingCard = styled.div`
  background: ${xdlColorBackground};
  border-color: ${xdlColorModalBorder};
  border-radius: 0 0 ${cornerRadiusXL} ${cornerRadiusXL};
  border-style: solid;
  border-width: ${scale005};
  box-shadow: ${dropShadowM};
  position: absolute;
  z-index: ${zIndexElevatedLayer4};

  padding: ${spaceM} ${spaceL};

  list-style: none;
  margin: 0;
  width: 100%;

  &:empty {
    border: none;
    box-shadow: none;
    padding: 0;
  }

  @media ${mediaTopBarHidden} {
    border-radius: ${cornerRadiusXL};
  }
`;
